import styled from "styled-components";
import Tabs from "common/Tabs/Tabs";

/**
 * New look: page tabs placed in the page intro toolbar (`usePageIntro`'s
 * `footer`). The toolbar row has no baseline, so the tabs drop their hairline
 * (it would stop short of the actions) and keep only the ink bar; the label
 * padding centres the labels on the same line as the toolbar's 32px actions.
 */
const NewLookIntroTabs = styled(Tabs)`
  &.ant-tabs-top > .ant-tabs-nav {
    margin: 0;
  }
  &.ant-tabs-top > .ant-tabs-nav::before {
    display: none;
  }
  &.ant-tabs .ant-tabs-tab {
    padding: 6px 0 8px;
    font-size: 14px;
  }
  &.ant-tabs .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 24px;
  }
`;

export default NewLookIntroTabs;
